import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';

import { fieldWrapperStyle } from 'common/style/fields.style';
import { generateSectionStyle } from 'common/style/cssStyleType';
import NameDescription from 'common/components/NameDescription';
import Rating from 'common/components/Rating';
import withSettings from 'editor/components/FormContent/Field/withSettings';

function FieldRating({
    fieldId,
    value,
    displayName,
    description,
    error,
    touched,
    setFieldTouched,
    setFieldValue,
    settingStyle,
    isRequired,
    ratingNumber,
    ratingType,
    ratingIcon,
    ratingIconChecked
}) {
    const { displayNameStyle, descStyle, answerStyle } = generateSectionStyle(settingStyle);
    function handleChange(val) {
        setFieldValue(fieldId, val);
        if (!touched) {
            setFieldTouched(fieldId);
        }
    }
    return (
        <div css={css(fieldWrapperStyle)} id={`section_${fieldId}`}>
            <NameDescription
                displayName={displayName}
                description={description}
                displayNameStyle={displayNameStyle}
                descStyle={descStyle}
                isRequired={isRequired}
            />
            <Rating
                value={value[fieldId] || 0}
                onChange={handleChange}
                style={answerStyle}
                range={ratingNumber}
                iconType={ratingType}
                customIconUrl={ratingIcon}
                customSelectedIconUrl={ratingIconChecked}
            />
            {error && touched && (
                <span css={css(errorStyle)} id="feedback">
                    {error}
                </span>
            )}
        </div>
    );
}

FieldRating.propTypes = {
    fieldId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    displayName: PropTypes.string,
    description: PropTypes.string,
    error: PropTypes.string,
    touched: PropTypes.bool,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
    settingStyle: PropTypes.object,
    isRequired: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    ratingNumber: PropTypes.number,
    ratingType: PropTypes.number,
    ratingIcon: PropTypes.string,
    ratingIconChecked: PropTypes.string
};

export default withSettings(FieldRating);

const errorStyle = `
    text-align: right;
    font-size: 0.8125rem;
    line-height: 1.1875rem;
    color: #D52027;
    float: right;
`;
